import { useState } from "react";
import AddCroppedImageForm, {
  AddCroppedImageFormProps,
} from "../images/AddCroppedImageForm";
import StyledDrawer from "../StyledDrawer";
import { Button } from "../ui/button";

export const CroppedImageInput = ({
  imagePosition,
  refetch,
  attachment,
  label,
  buttonLabel,
  title,
  imageURL,
  docId,
  aspect = 0.78,
  buildImageName: pageSlug,
}: AddCroppedImageFormProps & {
  title?: string;
  label?: string;
  buttonLabel: string;
  imageURL?: string;
  docId?: string;
  aspect?: number;
}) => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <>
      <div className="justify-between items-center gap-1.5 inline-flex pt-2">
        {label && (
          <p className="text-slate-700 text-sm font-medium font-['Raleway'] leading-normal">
            {label}
          </p>
        )}
        <StyledDrawer
          sheetProps={{
            open: isOpen,
            onOpenChange: setIsOpen,
          }}
          className="min-w-full"
          title={title}
          trigger={
            <Button className="font-semibold flex gap-2" variant="outline">
              {buttonLabel}
            </Button>
          }
        >
          <AddCroppedImageForm
            docId={docId}
            attachment={attachment}
            refetch={refetch}
            imagePosition={imagePosition}
            aspect={aspect}
            onSuccess={() => setIsOpen(false)}
            buildImageName={pageSlug}
          />
        </StyledDrawer>
      </div>
      {imageURL && (
        <img
          className="h-auto mt-3 w-1/2 mb-3"
          src={imageURL}
          alt="image couverture"
        />
      )}
    </>
  );
};
